import { Component, HostListener, OnInit } from "@angular/core";
import * as moment from "moment";
import "moment/locale/fr";
import { SwUpdate } from "@angular/service-worker";

declare var MathQuill;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"]
})
export class AppComponent implements OnInit {
  title = "app";
  MQ = (window as any).MathQuill.getInterface(2);
  constructor(private swUpdate: SwUpdate) {
    moment.locale("fr");
    //console.dir("MathQuill : ", this.MQ);
  }

  ngOnInit() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.available.subscribe(() => {
        if (confirm("Une nouvelle version est disponible ! L'installer ?")) {
          window.location.reload();
        }
      });
    }
  }

  @HostListener("window:beforeunload", ["$event"])
  beforeunloadHandler($event: Event) {
    /*  $event.preventDefault();
      console.log('By refreshing this page you may lost all data.'); */
  }
}
